/**
 * Loading Spinner Component
 * 
 * Displays a loading spinner using Cloudscape Spinner component
 */

import React from 'react';
import { Spinner, Box } from '@cloudscape-design/components';

interface LoadingSpinnerProps {
  size?: 'normal' | 'big' | 'large';
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'large', 
  message = 'Loading...' 
}) => {
  return (
    <Box textAlign="center" padding="xxl">
      <Spinner size={size} />
      {message && (
        <Box variant="p" padding={{ top: 's' }}>
          {message}
        </Box>
      )}
    </Box>
  );
};
